import React from "react";
import GenericForm from "../GenericForm";
import StringInput from "../../formElements/StringInput";
import BooleanInput from "../../formElements/BooleanInput";
import ColorInput from "../../formElements/ColorInput";

function BTKStateForm(props) {

    const formContent = (data, update) => (
        <>
            <StringInput name={'Stav'} label={'Stav'} value={data.Stav} onChange={update}/>
            <BooleanInput name={'Uzavrety'} label={'Uzavretý'} value={data.Uzavrety} onChange={update}/>
            <div className="col-sm-offset-2 col-sm-1">
                <ColorInput name={'Farba'} label={'Farba'} value={data.Farba} onChange={update}/>
            </div>
        </>
    )

    return (
        <GenericForm label="Stav BTK"
                     labelNew="Pridať Stav BTK"
                     baseUrl='/btk/btks_states/'
                     formContent={formContent}/>
    )

}

export default BTKStateForm
